import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';

import { AiTestingCompletedNotificationModel } from '../models/ai-testing-completed-notification-model';
import { AiTestingDefinitionService } from 'src/app/ai-testing/proxy/ai-testing.service';
import { AiTestingRunStatus } from 'src/app/ai-testing/proxy/ai-testing.model';

@Component({
  selector: 'cai-ai-testing-completed-notification',
  templateUrl: './ai-testing-completed-notification.component.html',
  styleUrls: ['./ai-testing-completed-notification.component.scss'],
  standalone: false,
})
@NotificationType('AiTestingCompletedNotification')
export class AiTestingCompletedNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    try {
      this.notification = JSON.parse(data.payload);
    } catch {
      this.notification = null;
    }
  }

  notification: AiTestingCompletedNotificationModel;

  constructor(
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
    private aiTestingService: AiTestingDefinitionService,
  ) {}

  showNotification(notification: NotificationModel) {
    try {
      this.notification = JSON.parse(notification.payload);
    } catch {
      return;
    }

    if (!this.notification) {
      return;
    }

    // Only refresh list if status is Success, Error, or Cancelled
    if (
      this.notification.runStatus === AiTestingRunStatus.Success ||
      this.notification.runStatus === AiTestingRunStatus.Error ||
      this.notification.runStatus === AiTestingRunStatus.Cancelled
    ) {
      // Refresh the runs list if viewing the affected test
      this.aiTestingService.refreshRunsList$.next(this.notification.aiTestingDefinitionId);
      // Refresh the tests list if viewing the affected project
      this.aiTestingService.refreshTestsList$.next(this.notification.projectId);

      // Show appropriate notification based on status
      const message = this.getMessage();
      if (message) {
        if (this.notification.runStatus === AiTestingRunStatus.Success) {
          this.toasterService.success(message);
        } else if (this.notification.runStatus === AiTestingRunStatus.Error) {
          this.toasterService.error(message);
        } else if (this.notification.runStatus === AiTestingRunStatus.Cancelled) {
          this.toasterService.warn(message);
        }
      }
    }
  }

  public getMessage(): string {
    let message: string;
    if (this.notification.runStatus === AiTestingRunStatus.Success) {
      message = this.localizationService.instant(
        'AiTesting::TestCompletedSuccessfully',
        this.notification.name,
      );
    } else if (this.notification.runStatus === AiTestingRunStatus.Error) {
      message = this.localizationService.instant(
        'AiTesting::TestCompletedWithError',
        this.notification.name,
      );
    } else if (this.notification.runStatus === AiTestingRunStatus.Cancelled) {
      message = this.localizationService.instant(
        'AiTesting::TestCancelled',
        this.notification.name,
      );
    }

    return message || '';
  }
}
